import { Typography } from 'antd'
import React from 'react'

import { Label as LabelPreview } from '../../components/Label/Label'
import {
  ColorPalleteDeafultOption,
  ColorPalleteKey,
} from '../../utils/collorPallete'
import {
  IconPalleteDeafultOption,
  IconPalleteKey,
} from '../../utils/iconPallete'
import { LabelDetail } from '../../utils/labelsTypes'

interface LabelDetailPageTitleProps {
  label: LabelDetail
}
const style = { marginBottom: 0 }

export const LabelDetailPageTitle: React.FC<LabelDetailPageTitleProps> = ({
  label,
}) => (
  <div className="flex space-x-4 items-center">
    <Typography.Title style={style} level={3}>
      Detail štítku
    </Typography.Title>
    <div className="scale-125">
      <LabelPreview
        colorKey={
          (label?.colorKey as ColorPalleteKey) || ColorPalleteDeafultOption
        }
        iconKey={(label?.iconKey as IconPalleteKey) || IconPalleteDeafultOption}
        name={label?.name || ''}
        description={label?.description || ''}
      />
    </div>
  </div>
)
